const sendCustomEvent = (eventChannel, eventType, payload = {}, analyticPayload = void 0) => {
  const event = new CustomEvent(eventChannel, {
    detail: {
      type: eventType,
      analytic: analyticPayload,
      ...payload
    }
  });
  document.dispatchEvent(event);
};
export {
  sendCustomEvent
};
